import PropTypes from "prop-types";

import { PublishedStatusTypes } from "../../../enums";

export default PropTypes.oneOf([
  PublishedStatusTypes.draft,
  PublishedStatusTypes.published,
  PublishedStatusTypes.notPublished,
]);
